export default "__VITE_ASSET__BQX1Y3Tn__"